////////////////////////////////////////////////////////////////////////////////
// Fixers
////////////////////////////////////////////////////////////////////////////////

 /**
  * A collection of common fixes for common front-end problems.
  *
  * @author Mark Notton <mark@marknotton.uk>
  *
  * @license Copyright 2019 Mark Notton
  *
  * @todo Make this jQuery independant
  *
  * Licensed under the Apache License, Version 2.0 (the "License");
  * you may not use this file except in compliance with the License.
  * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
  *
  * Unless required by applicable law or agreed to in writing, software
  * distributed under the License is distributed on an "AS IS" BASIS,
  * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  * See the License for the specific language governing permissions and
  * limitations under the License.
  */

class Fixers {

  constructor () {

    Fixers.logging()
    Fixers.init()

  }

  /** --------------------------------------------------------------------------
   * Initialiser
   * ---------------------------------------------------------------------------
   * This should be ran on each new page load or HistoryAPI state change
   */

  static init() {

    Fixers.images()
    Fixers.links()
    Fixers.videos()

  }

  /** --------------------------------------------------------------------------
   * Image Sourcesets
   * ---------------------------------------------------------------------------
   * Add 'srcset' fallback for IE and Edge browsers when using feature-images custom elements
   * @method images
   * @param {String} customElement Selector string for all image elements with srcset markup
   */

  static images (customElement = 'figure[image]') {
    if (('objectFit' in document.documentElement.style) == false || (typeof browser !== 'undefined' && browser.name == 'edge') ) {
      console.warn(`Object Fit is not supported by this browser. All "${customElement}" will fallback to css background images instead.` )
      document.querySelectorAll(customElement).forEach(element => {
        if ( element.hasAttribute('data-desktop') || element.hasAttribute('data-mobile') ) {
          element.style.backgroundImage = `url('${element.getAttribute('data-desktop') || element.getAttribute('data-mobile')}')`
          element.getElementsByTagName('img')[0].style.display = 'none'
        }
      })
    }
  }

  /** --------------------------------------------------------------------------
   * External Links
   * ---------------------------------------------------------------------------
   * Force external links and documents to open in new tabs securely.
   * @method links
   */

  static links () {

    let extensions = ['html', 'htm', 'xhtml', 'php']
    let protocols  = ['callto', 'tel', 'mailto', 'skype']

    document.querySelectorAll('a:not([href^="#"])').forEach(element => {

      let string = element.getAttribute('href')
      let parser = new URL(string, location)

      let isWebFile = parser.pathname.includes('.') && !extensions.some(ext => parser.pathname.endsWith('.' + ext))
      let isSpecialProtocol = protocols.some(protocol => protocol+':' == parser.protocol)
      let isExternalUrl = (string) => {
        if (typeof string !== 'object') {
          let match = string.match(/^([^:\/?#]+:)?(?:\/\/([^\/?#]*))?([^?#]+)?(\?[^#]*)?(#.*)?/);
          if (typeof match[1] === "string" && match[1].length > 0 && match[1].toLowerCase() !== location.protocol) return true;
          if (typeof match[2] === "string" && match[2].length > 0 && match[2].replace(new RegExp(":("+{"http:":80,"https:":443}[location.protocol]+")?$"), "") !== location.host) return true;
        }
        return false;
      }

      if ( isWebFile || isSpecialProtocol || isExternalUrl(string)) {
        element.setAttribute("rel", "noopener");
        element.setAttribute("target", "_blank");
      }

    });

  }

  /** --------------------------------------------------------------------------
   * Video Container
   * ---------------------------------------------------------------------------
   * Wrap all iframe videos in a <video-container> element
   * @param {String} customElement Selector string for all image elements with srcset markup
   * @method videos
   */

  static videos (containerClass = 'video-container') {

    let iframes = document.querySelectorAll(`iframe[src*="youtube"], iframe[src*="vimeo"]`);

    for (const iframe of iframes) {
      if ( !iframe.parentNode.classList.contains(containerClass) && iframe.parentNode.nodeName != 'VIDEO-CONTAINER' ) {
        const element = document.createElement(containerClass);
        iframe.parentElement.insertBefore(element, iframe);
        element.appendChild(iframe);
      }
    }
  }

  /** --------------------------------------------------------------------------
   * Console Logging
   * ---------------------------------------------------------------------------
   * Disable console logging in Production environments for non-admins as a security measure.
   * @method logging
   */

	static logging () {
		if ( document.body.classList.contains('production-environment') && !document.body.classList.contains('admin') ) {

		  window['_logger'] = { status : true, old : null };

		  Object.defineProperty(window, 'logger', {
		    get : () => {
		      return window._logger.status;
		    },
		    set : (value = true) => {
		      if ( typeof value == 'boolean') {
		        window._logger.status = value;
		        if (value) {
		          // Enable Logger
		          if(window._logger.old == null) { return; }
		          window['console']['log'] = window._logger.old;
		        } else {
		          // Disable Logger
		          window._logger.old = console.log;
		          window['console']['log'] = function() {};
		        }
		      }
		    }
		  });

		  logger = false;

		}
	}

}
